import { toast } from "react-toastify";

export function digitsOnlyPhone(phone) {
  if (phone == null || phone === "") return "";
  return String(phone).replace(/\D/g, "");
}

export async function copyTextToClipboard(text) {
  const value = text == null ? "" : String(text);
  if (!value.trim()) {
    toast.warn("Nothing to copy");
    return false;
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      toast.success("Message copied to clipboard", { autoClose: 1500 });
      return true;
    }
  } catch {
    // fall through
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    toast.success("Message copied to clipboard", { autoClose: 1500 });
    return true;
  } catch {
    toast.error("Copy failed. Please copy manually.");
    return false;
  }
}

export function openWhatsAppWeb(phone, text) {
  const digits = digitsOnlyPhone(phone);
  if (!digits) {
    toast.warn("No mobile number available to open WhatsApp");
    return false;
  }

  const url = `https://web.whatsapp.com/send?phone=${digits}&text=${encodeURIComponent(text || "")}`;
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}

export async function copyAndOpenWhatsApp(phone, text) {
  await copyTextToClipboard(text);
  openWhatsAppWeb(phone, text);
}

export function buildRegistrationApprovedMessage({ name, userName, password }) {
  const displayName = name?.trim() || "there";
  const lines = [
    `Hello ${displayName},`,
    "",
    "Your user account has been approved and created.",
    "",
    `Username: ${userName || "—"}`,
    `Password: ${password || "—"}`,
    "",
    "Please log in and change your password after your first login.",
  ];
  return lines.join("\n");
}

export function buildRegistrationRejectedMessage({ name, employeeId, inactiveReason }) {
  const displayName = name?.trim() || "there";
  const lines = [
    `Hello ${displayName},`,
    "",
    "Your registration request has been rejected.",
    "",
    employeeId ? `Employee ID: ${employeeId}` : null,
    `Reason: ${inactiveReason || "Not provided"}`,
    "",
    "If you have questions, please contact your administrator.",
  ].filter((line) => line !== null);
  return lines.join("\n");
}
